// Textes du portail client, dans la langue du client (langue majoritaire de
// ses fiches, rendue par GET /api/portal/me). Exception voulue à la règle
// « interface en anglais » : ces pages sont lues par les clients, pas par
// l'équipe. Langues = celles des documents (buildDocumentLines) ; défaut EN.

const T = {
  en: {
    nav_orders: 'Current orders',
    nav_history: 'Previous orders',
    nav_invoices: 'Invoices',
    nav_account: 'My account',
    sign_out: 'Sign out',
    loading: 'Loading…',
    load_error: 'The data could not be loaded. Please try again.',
    retry: 'Retry',
    order: 'Order',
    your_ref: 'Your reference',
    order_date: 'Order date',
    requested_delivery: 'Requested delivery',
    confirmed_delivery: 'Confirmed delivery',
    awaiting_confirmation: 'Being confirmed',
    truck_planned: 'Truck planned',
    truck_loading: 'loading on {date}',
    truck_delivery: 'estimated delivery {date}',
    truck_not_planned: 'Truck not planned yet',
    product: 'Product',
    quantity: 'Quantity',
    unit_price: 'Unit price excl. VAT',
    line_total: 'Total excl. VAT',
    vat: 'VAT',
    total_excl: 'Total excl. VAT',
    total_incl: 'Total incl. VAT',
    availability: 'Availability',
    in_stock: 'In stock',
    to_prepare: 'To prepare',
    stock_hint: 'In stock: the goods are ready. To prepare: the goods are being produced or prepared for your order.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF not available yet',
    no_current_orders: 'You have no order in progress.',
    no_previous_orders: 'You have no previous order.',
    invoice: 'Invoice',
    invoices_of_order: 'Invoice(s)',
    invoice_no: 'Number',
    date: 'Date',
    type: 'Type',
    kind_invoice: 'Invoice',
    kind_credit_note: 'Credit note',
    kind_advance: 'Advance invoice',
    amount_incl: 'Amount incl. VAT',
    no_invoices: 'You have no invoice yet.',
    latest_only: 'The 100 most recent are shown.',
    companies: 'Companies',
    email: 'E-mail',
    change_password: 'Change my password',
    current_password: 'Current password',
    new_password: 'New password',
    confirm_password: 'Confirm the new password',
    password_rules: 'At least 12 characters. A phrase of several unrelated words works well.',
    password_mismatch: 'The two new passwords do not match.',
    password_changed: 'Your password has been changed.',
    save: 'Save',
    download_error: 'The document could not be downloaded.',
    pdf_no_pdf: 'This document is not available for download yet. Please contact us.',
    pdf_outdated: 'This invoice is being updated. Please contact us to receive it.',
    pdf_not_found: 'Document not found.',
    nav_quotations: 'Quotations',
    quotation: 'Quotation',
    status: 'Status',
    status_pending: 'Pending',
    status_in_progress: 'In progress',
    status_invoiced: 'Invoiced',
    transport: 'Transport',
    transport_no: 'Transport no.',
    loading_date: 'Loading date',
    estimated_delivery: 'Estimated delivery',
    truck_plate: 'Truck plate',
    trailer_plate: 'Trailer plate',
    aviz: 'Delivery note (aviz)',
    not_planned: 'Not planned yet',
    leaving_teiu: 'Departure from Teiu: {date}',
    leaving_teiu_today: 'Leaving Teiu today',
    today: 'Today',
    legend_production: 'Production in progress',
    legend_stock_ready: 'Stock ready',
    legend_transport_searching: 'Searching for a carrier',
    legend_transport_confirmed: 'Carrier confirmed',
    incoterms: 'Incoterms',
    view_pdf: 'View PDF',
    back: 'Back',
    trucks_planned: 'Trucks planned',
    no_quotations: 'You have no pending quotation.',
    company: 'Company',
    vat_pct: 'VAT %',
    products: 'Products',
    security: 'Security',
    twofa_title: 'Two-factor authentication',
    twofa_on: 'Enabled',
    twofa_off: 'Not enabled',
    twofa_optional: 'Optional: a code is asked in addition to your password when you sign in.',
    twofa_enable: 'Enable',
    twofa_disable: 'Disable',
    twofa_method_totp: 'Authenticator app',
    twofa_method_email: 'E-mail code',
    twofa_code: 'Code',
    twofa_send_code: 'Send me a code',
    twofa_code_sent: 'A code has been sent to your e-mail address.',
    twofa_enabled_ok: 'Two-factor authentication is enabled.',
    twofa_disabled_ok: 'Two-factor authentication is disabled.',
    cancel: 'Cancel',
    nav_dashboard: 'Dashboard',
    volume: 'Volume',
    volume_m3: 'Volume (m³)',
    total_volume: 'Total volume',
    ready: 'Ready',
    destination: 'Destination',
    display_map: 'Display the map',
    upcoming_departures: 'Upcoming departures',
    latest_invoices: 'Latest invoices',
    purchases_12m: 'Your orders over the last 12 months',
    ordered_this_year: 'Ordered this year',
    volume_in_progress: 'Volume in progress',
    ref_xylo: 'XYLO ref.',
    client: 'Client',
    vat_number: 'VAT number',
    phone: 'Phone',
    billing_address: 'Billing address',
    delivery_address: 'Delivery address',
    advance_payment: 'Advance payment',
    fsc: 'FSC certified',
    yes: 'Yes',
    no: 'No',
    documents: 'Documents',
    approval_date: 'Approval date',
    no_delivery_address: 'No delivery address',
    no_upcoming: 'No truck planned at the moment.',
    welcome: 'Welcome',
    orders_count: 'Orders',
    amount_excl: 'Amount excl. VAT',
    click_display_map: 'Click to display the map',
    pending_count: 'Pending quotations: {n}',
    invoices_count: 'Invoices: {n}',
    previous_count: 'Previous orders: {n}',
    ordered: 'ordered',
    details: 'Details',
    on_the_way: 'On the way',
    all_statuses: 'All',
    on_the_road: 'On the road',
    no_on_the_road: 'No truck on the road at the moment.'
  },
  fr: {
    nav_orders: 'Commandes en cours',
    nav_history: 'Commandes précédentes',
    nav_invoices: 'Factures',
    nav_account: 'Mon compte',
    sign_out: 'Se déconnecter',
    loading: 'Chargement…',
    load_error: 'Les données n\'ont pas pu être chargées. Veuillez réessayer.',
    retry: 'Réessayer',
    order: 'Commande',
    your_ref: 'Votre référence',
    order_date: 'Date de commande',
    requested_delivery: 'Livraison souhaitée',
    confirmed_delivery: 'Livraison confirmée',
    awaiting_confirmation: 'En cours de confirmation',
    truck_planned: 'Camion prévu',
    truck_loading: 'chargement le {date}',
    truck_delivery: 'livraison estimée le {date}',
    truck_not_planned: 'Camion pas encore planifié',
    product: 'Produit',
    quantity: 'Quantité',
    unit_price: 'Prix unitaire HT',
    line_total: 'Total HT',
    vat: 'TVA',
    total_excl: 'Total HT',
    total_incl: 'Total TTC',
    availability: 'Disponibilité',
    in_stock: 'En stock',
    to_prepare: 'À préparer',
    stock_hint: 'En stock : la marchandise est prête. À préparer : la marchandise est en production ou en préparation pour votre commande.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF pas encore disponible',
    no_current_orders: 'Vous n\'avez aucune commande en cours.',
    no_previous_orders: 'Vous n\'avez aucune commande précédente.',
    invoice: 'Facture',
    invoices_of_order: 'Facture(s)',
    invoice_no: 'Numéro',
    date: 'Date',
    type: 'Type',
    kind_invoice: 'Facture',
    kind_credit_note: 'Note de crédit',
    kind_advance: 'Facture d\'acompte',
    amount_incl: 'Montant TTC',
    no_invoices: 'Vous n\'avez pas encore de facture.',
    latest_only: 'Les 100 plus récentes sont affichées.',
    companies: 'Sociétés',
    email: 'E-mail',
    change_password: 'Changer mon mot de passe',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer le nouveau mot de passe',
    password_rules: 'Au moins 12 caractères. Une phrase de plusieurs mots sans rapport entre eux convient bien.',
    password_mismatch: 'Les deux nouveaux mots de passe ne correspondent pas.',
    password_changed: 'Votre mot de passe a été modifié.',
    save: 'Enregistrer',
    download_error: 'Le document n\'a pas pu être téléchargé.',
    pdf_no_pdf: 'Ce document n\'est pas encore disponible au téléchargement. Merci de nous contacter.',
    pdf_outdated: 'Cette facture est en cours de mise à jour. Merci de nous contacter pour la recevoir.',
    pdf_not_found: 'Document introuvable.',
    nav_quotations: 'Devis',
    quotation: 'Devis',
    status: 'Statut',
    status_pending: 'En attente',
    status_in_progress: 'En cours',
    status_invoiced: 'Facturée',
    transport: 'Transport',
    transport_no: 'N° de transport',
    loading_date: 'Date de chargement',
    estimated_delivery: 'Livraison estimée',
    truck_plate: 'Plaque camion',
    trailer_plate: 'Plaque remorque',
    aviz: 'Aviz d\'accompagnement',
    not_planned: 'Pas encore planifié',
    leaving_teiu: 'Départ de Teiu : {date}',
    leaving_teiu_today: 'Départ de Teiu aujourd\'hui',
    today: 'Aujourd\'hui',
    legend_production: 'Production en cours',
    legend_stock_ready: 'Stock prêt',
    legend_transport_searching: 'Transporteur recherché',
    legend_transport_confirmed: 'Transporteur confirmé',
    incoterms: 'Incoterms',
    view_pdf: 'Voir le PDF',
    back: 'Retour',
    trucks_planned: 'Camions prévus',
    no_quotations: 'Vous n\'avez aucun devis en attente.',
    company: 'Société',
    vat_pct: 'TVA %',
    products: 'Produits',
    security: 'Sécurité',
    twofa_title: 'Double authentification',
    twofa_on: 'Activée',
    twofa_off: 'Non activée',
    twofa_optional: 'Facultatif : un code vous est demandé en plus du mot de passe à la connexion.',
    twofa_enable: 'Activer',
    twofa_disable: 'Désactiver',
    twofa_method_totp: 'Application d\'authentification',
    twofa_method_email: 'Code par e-mail',
    twofa_code: 'Code',
    twofa_send_code: 'M\'envoyer un code',
    twofa_code_sent: 'Un code a été envoyé à votre adresse e-mail.',
    twofa_enabled_ok: 'La double authentification est activée.',
    twofa_disabled_ok: 'La double authentification est désactivée.',
    cancel: 'Annuler',
    nav_dashboard: 'Tableau de bord',
    volume: 'Volume',
    volume_m3: 'Volume (m³)',
    total_volume: 'Volume total',
    ready: 'Prête',
    destination: 'Destination',
    display_map: 'Afficher la carte',
    upcoming_departures: 'Prochains départs',
    latest_invoices: 'Dernières factures',
    purchases_12m: 'Vos commandes sur les 12 derniers mois',
    ordered_this_year: 'Commandé cette année',
    volume_in_progress: 'Volume en cours',
    ref_xylo: 'Réf. XYLO',
    client: 'Client',
    vat_number: 'N° de TVA',
    phone: 'Téléphone',
    billing_address: 'Adresse de facturation',
    delivery_address: 'Adresse de livraison',
    advance_payment: 'Acompte',
    fsc: 'Certifié FSC',
    yes: 'Oui',
    no: 'Non',
    documents: 'Documents',
    approval_date: 'Date d\'acceptation',
    no_delivery_address: 'Pas d\'adresse de livraison',
    no_upcoming: 'Aucun camion prévu pour le moment.',
    welcome: 'Bienvenue',
    orders_count: 'Commandes',
    amount_excl: 'Montant HT',
    click_display_map: 'Cliquez pour afficher la carte',
    pending_count: 'Devis en attente : {n}',
    invoices_count: 'Factures : {n}',
    previous_count: 'Commandes précédentes : {n}',
    ordered: 'commandés',
    details: 'Détails',
    on_the_way: 'En route',
    all_statuses: 'Tous',
    on_the_road: 'Sur la route',
    no_on_the_road: 'Aucun camion sur la route en ce moment.'
  },
  ro: {
    nav_orders: 'Comenzi în curs',
    nav_history: 'Comenzi anterioare',
    nav_invoices: 'Facturi',
    nav_account: 'Contul meu',
    sign_out: 'Deconectare',
    loading: 'Se încarcă…',
    load_error: 'Datele nu au putut fi încărcate. Vă rugăm să încercați din nou.',
    retry: 'Reîncercați',
    order: 'Comanda',
    your_ref: 'Referința dvs.',
    order_date: 'Data comenzii',
    requested_delivery: 'Livrare dorită',
    confirmed_delivery: 'Livrare confirmată',
    awaiting_confirmation: 'În curs de confirmare',
    truck_planned: 'Camion planificat',
    truck_loading: 'încărcare pe {date}',
    truck_delivery: 'livrare estimată pe {date}',
    truck_not_planned: 'Camionul nu este încă planificat',
    product: 'Produs',
    quantity: 'Cantitate',
    unit_price: 'Preț unitar fără TVA',
    line_total: 'Total fără TVA',
    vat: 'TVA',
    total_excl: 'Total fără TVA',
    total_incl: 'Total cu TVA',
    availability: 'Disponibilitate',
    in_stock: 'În stoc',
    to_prepare: 'De pregătit',
    stock_hint: 'În stoc: marfa este pregătită. De pregătit: marfa este în producție sau în pregătire pentru comanda dvs.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF încă indisponibil',
    no_current_orders: 'Nu aveți nicio comandă în curs.',
    no_previous_orders: 'Nu aveți nicio comandă anterioară.',
    invoice: 'Factura',
    invoices_of_order: 'Factura(i)',
    invoice_no: 'Număr',
    date: 'Data',
    type: 'Tip',
    kind_invoice: 'Factură',
    kind_credit_note: 'Factură storno',
    kind_advance: 'Factură de avans',
    amount_incl: 'Valoare cu TVA',
    no_invoices: 'Nu aveți încă nicio factură.',
    latest_only: 'Sunt afișate cele mai recente 100.',
    companies: 'Societăți',
    email: 'E-mail',
    change_password: 'Schimbă parola',
    current_password: 'Parola actuală',
    new_password: 'Parola nouă',
    confirm_password: 'Confirmați parola nouă',
    password_rules: 'Cel puțin 12 caractere. O frază din mai multe cuvinte fără legătură între ele este o alegere bună.',
    password_mismatch: 'Cele două parole noi nu coincid.',
    password_changed: 'Parola a fost schimbată.',
    save: 'Salvează',
    download_error: 'Documentul nu a putut fi descărcat.',
    pdf_no_pdf: 'Acest document nu este încă disponibil pentru descărcare. Vă rugăm să ne contactați.',
    pdf_outdated: 'Această factură este în curs de actualizare. Vă rugăm să ne contactați pentru a o primi.',
    pdf_not_found: 'Document negăsit.',
    nav_quotations: 'Oferte',
    quotation: 'Ofertă',
    status: 'Stare',
    status_pending: 'În așteptare',
    status_in_progress: 'În curs',
    status_invoiced: 'Facturată',
    transport: 'Transport',
    transport_no: 'Nr. transport',
    loading_date: 'Data încărcării',
    estimated_delivery: 'Livrare estimată',
    truck_plate: 'Nr. înmatriculare camion',
    trailer_plate: 'Nr. înmatriculare remorcă',
    aviz: 'Aviz de însoțire',
    not_planned: 'Încă neplanificat',
    leaving_teiu: 'Plecare din Teiu: {date}',
    leaving_teiu_today: 'Pleacă din Teiu astăzi',
    today: 'Astăzi',
    legend_production: 'Producție în curs',
    legend_stock_ready: 'Stoc pregătit',
    legend_transport_searching: 'Căutăm transportatorul',
    legend_transport_confirmed: 'Transportator confirmat',
    incoterms: 'Incoterms',
    view_pdf: 'Vezi PDF',
    back: 'Înapoi',
    trucks_planned: 'Camioane planificate',
    no_quotations: 'Nu aveți nicio ofertă în așteptare.',
    company: 'Societate',
    vat_pct: 'TVA %',
    products: 'Produse',
    security: 'Securitate',
    twofa_title: 'Autentificare în doi pași',
    twofa_on: 'Activată',
    twofa_off: 'Neactivată',
    twofa_optional: 'Opțional: la conectare vi se cere un cod pe lângă parolă.',
    twofa_enable: 'Activează',
    twofa_disable: 'Dezactivează',
    twofa_method_totp: 'Aplicație de autentificare',
    twofa_method_email: 'Cod prin e-mail',
    twofa_code: 'Cod',
    twofa_send_code: 'Trimite-mi un cod',
    twofa_code_sent: 'Un cod a fost trimis la adresa dvs. de e-mail.',
    twofa_enabled_ok: 'Autentificarea în doi pași este activată.',
    twofa_disabled_ok: 'Autentificarea în doi pași este dezactivată.',
    cancel: 'Anulează',
    nav_dashboard: 'Tablou de bord',
    volume: 'Volum',
    volume_m3: 'Volum (m³)',
    total_volume: 'Volum total',
    ready: 'Pregătită',
    destination: 'Destinație',
    display_map: 'Afișează harta',
    upcoming_departures: 'Plecări viitoare',
    latest_invoices: 'Ultimele facturi',
    purchases_12m: 'Comenzile dvs. în ultimele 12 luni',
    ordered_this_year: 'Comandat anul acesta',
    volume_in_progress: 'Volum în curs',
    ref_xylo: 'Ref. XYLO',
    client: 'Client',
    vat_number: 'Cod TVA',
    phone: 'Telefon',
    billing_address: 'Adresa de facturare',
    delivery_address: 'Adresa de livrare',
    advance_payment: 'Avans',
    fsc: 'Certificat FSC',
    yes: 'Da',
    no: 'Nu',
    documents: 'Documente',
    approval_date: 'Data acceptării',
    no_delivery_address: 'Fără adresă de livrare',
    no_upcoming: 'Niciun camion planificat momentan.',
    welcome: 'Bine ați venit',
    orders_count: 'Comenzi',
    amount_excl: 'Valoare fără TVA',
    click_display_map: 'Faceți clic pentru a afișa harta',
    pending_count: 'Oferte în așteptare: {n}',
    invoices_count: 'Facturi: {n}',
    previous_count: 'Comenzi anterioare: {n}',
    ordered: 'comandați',
    details: 'Detalii',
    on_the_way: 'În drum',
    all_statuses: 'Toate',
    on_the_road: 'Pe drum',
    no_on_the_road: 'Niciun camion pe drum momentan.'
  },
  de: {
    nav_orders: 'Laufende Bestellungen',
    nav_history: 'Frühere Bestellungen',
    nav_invoices: 'Rechnungen',
    nav_account: 'Mein Konto',
    sign_out: 'Abmelden',
    loading: 'Wird geladen…',
    load_error: 'Die Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
    order: 'Bestellung',
    your_ref: 'Ihre Referenz',
    order_date: 'Bestelldatum',
    requested_delivery: 'Gewünschte Lieferung',
    confirmed_delivery: 'Bestätigte Lieferung',
    awaiting_confirmation: 'Wird bestätigt',
    truck_planned: 'LKW geplant',
    truck_loading: 'Verladung am {date}',
    truck_delivery: 'voraussichtliche Lieferung am {date}',
    truck_not_planned: 'LKW noch nicht geplant',
    product: 'Produkt',
    quantity: 'Menge',
    unit_price: 'Stückpreis netto',
    line_total: 'Summe netto',
    vat: 'MwSt.',
    total_excl: 'Summe netto',
    total_incl: 'Summe brutto',
    availability: 'Verfügbarkeit',
    in_stock: 'Auf Lager',
    to_prepare: 'In Vorbereitung',
    stock_hint: 'Auf Lager: die Ware ist bereit. In Vorbereitung: die Ware wird für Ihre Bestellung produziert oder vorbereitet.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF noch nicht verfügbar',
    no_current_orders: 'Sie haben keine laufende Bestellung.',
    no_previous_orders: 'Sie haben keine frühere Bestellung.',
    invoice: 'Rechnung',
    invoices_of_order: 'Rechnung(en)',
    invoice_no: 'Nummer',
    date: 'Datum',
    type: 'Art',
    kind_invoice: 'Rechnung',
    kind_credit_note: 'Gutschrift',
    kind_advance: 'Anzahlungsrechnung',
    amount_incl: 'Betrag brutto',
    no_invoices: 'Sie haben noch keine Rechnung.',
    latest_only: 'Die 100 neuesten werden angezeigt.',
    companies: 'Firmen',
    email: 'E-Mail',
    change_password: 'Passwort ändern',
    current_password: 'Aktuelles Passwort',
    new_password: 'Neues Passwort',
    confirm_password: 'Neues Passwort bestätigen',
    password_rules: 'Mindestens 12 Zeichen. Ein Satz aus mehreren zusammenhanglosen Wörtern eignet sich gut.',
    password_mismatch: 'Die beiden neuen Passwörter stimmen nicht überein.',
    password_changed: 'Ihr Passwort wurde geändert.',
    save: 'Speichern',
    download_error: 'Das Dokument konnte nicht heruntergeladen werden.',
    pdf_no_pdf: 'Dieses Dokument steht noch nicht zum Download bereit. Bitte kontaktieren Sie uns.',
    pdf_outdated: 'Diese Rechnung wird gerade aktualisiert. Bitte kontaktieren Sie uns, um sie zu erhalten.',
    pdf_not_found: 'Dokument nicht gefunden.',
    nav_quotations: 'Angebote',
    quotation: 'Angebot',
    status: 'Status',
    status_pending: 'Ausstehend',
    status_in_progress: 'In Bearbeitung',
    status_invoiced: 'Fakturiert',
    transport: 'Transport',
    transport_no: 'Transport-Nr.',
    loading_date: 'Ladedatum',
    estimated_delivery: 'Voraussichtliche Lieferung',
    truck_plate: 'LKW-Kennzeichen',
    trailer_plate: 'Anhänger-Kennzeichen',
    aviz: 'Begleitschein (Aviz)',
    not_planned: 'Noch nicht geplant',
    leaving_teiu: 'Abfahrt ab Teiu: {date}',
    leaving_teiu_today: 'Abfahrt ab Teiu heute',
    today: 'Heute',
    legend_production: 'Produktion läuft',
    legend_stock_ready: 'Ware bereit',
    legend_transport_searching: 'Spediteur wird gesucht',
    legend_transport_confirmed: 'Spediteur bestätigt',
    incoterms: 'Incoterms',
    view_pdf: 'PDF ansehen',
    back: 'Zurück',
    trucks_planned: 'Geplante LKW',
    no_quotations: 'Sie haben kein ausstehendes Angebot.',
    company: 'Firma',
    vat_pct: 'MwSt. %',
    products: 'Produkte',
    security: 'Sicherheit',
    twofa_title: 'Zwei-Faktor-Authentifizierung',
    twofa_on: 'Aktiviert',
    twofa_off: 'Nicht aktiviert',
    twofa_optional: 'Optional: Bei der Anmeldung wird zusätzlich zum Passwort ein Code abgefragt.',
    twofa_enable: 'Aktivieren',
    twofa_disable: 'Deaktivieren',
    twofa_method_totp: 'Authenticator-App',
    twofa_method_email: 'Code per E-Mail',
    twofa_code: 'Code',
    twofa_send_code: 'Code zusenden',
    twofa_code_sent: 'Ein Code wurde an Ihre E-Mail-Adresse gesendet.',
    twofa_enabled_ok: 'Die Zwei-Faktor-Authentifizierung ist aktiviert.',
    twofa_disabled_ok: 'Die Zwei-Faktor-Authentifizierung ist deaktiviert.',
    cancel: 'Abbrechen',
    nav_dashboard: 'Dashboard',
    volume: 'Volumen',
    volume_m3: 'Volumen (m³)',
    total_volume: 'Gesamtvolumen',
    ready: 'Bereit',
    destination: 'Bestimmungsort',
    display_map: 'Karte anzeigen',
    upcoming_departures: 'Nächste Abfahrten',
    latest_invoices: 'Letzte Rechnungen',
    purchases_12m: 'Ihre Bestellungen der letzten 12 Monate',
    ordered_this_year: 'Dieses Jahr bestellt',
    volume_in_progress: 'Volumen in Bearbeitung',
    ref_xylo: 'XYLO-Ref.',
    client: 'Kunde',
    vat_number: 'USt-IdNr.',
    phone: 'Telefon',
    billing_address: 'Rechnungsadresse',
    delivery_address: 'Lieferadresse',
    advance_payment: 'Anzahlung',
    fsc: 'FSC-zertifiziert',
    yes: 'Ja',
    no: 'Nein',
    documents: 'Dokumente',
    approval_date: 'Annahmedatum',
    no_delivery_address: 'Keine Lieferadresse',
    no_upcoming: 'Derzeit ist kein LKW geplant.',
    welcome: 'Willkommen',
    orders_count: 'Bestellungen',
    amount_excl: 'Betrag netto',
    click_display_map: 'Klicken Sie, um die Karte anzuzeigen',
    pending_count: 'Ausstehende Angebote: {n}',
    invoices_count: 'Rechnungen: {n}',
    previous_count: 'Frühere Bestellungen: {n}',
    ordered: 'bestellt',
    details: 'Details',
    on_the_way: 'Unterwegs',
    all_statuses: 'Alle',
    on_the_road: 'Unterwegs',
    no_on_the_road: 'Derzeit ist kein LKW unterwegs.'
  },
  es: {
    nav_orders: 'Pedidos en curso',
    nav_history: 'Pedidos anteriores',
    nav_invoices: 'Facturas',
    nav_account: 'Mi cuenta',
    sign_out: 'Cerrar sesión',
    loading: 'Cargando…',
    load_error: 'No se han podido cargar los datos. Inténtelo de nuevo.',
    retry: 'Reintentar',
    order: 'Pedido',
    your_ref: 'Su referencia',
    order_date: 'Fecha del pedido',
    requested_delivery: 'Entrega solicitada',
    confirmed_delivery: 'Entrega confirmada',
    awaiting_confirmation: 'En confirmación',
    truck_planned: 'Camión previsto',
    truck_loading: 'carga el {date}',
    truck_delivery: 'entrega estimada el {date}',
    truck_not_planned: 'Camión aún no planificado',
    product: 'Producto',
    quantity: 'Cantidad',
    unit_price: 'Precio unitario sin IVA',
    line_total: 'Total sin IVA',
    vat: 'IVA',
    total_excl: 'Total sin IVA',
    total_incl: 'Total con IVA',
    availability: 'Disponibilidad',
    in_stock: 'En stock',
    to_prepare: 'Por preparar',
    stock_hint: 'En stock: la mercancía está lista. Por preparar: la mercancía se está produciendo o preparando para su pedido.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF aún no disponible',
    no_current_orders: 'No tiene ningún pedido en curso.',
    no_previous_orders: 'No tiene ningún pedido anterior.',
    invoice: 'Factura',
    invoices_of_order: 'Factura(s)',
    invoice_no: 'Número',
    date: 'Fecha',
    type: 'Tipo',
    kind_invoice: 'Factura',
    kind_credit_note: 'Factura rectificativa',
    kind_advance: 'Factura de anticipo',
    amount_incl: 'Importe con IVA',
    no_invoices: 'Todavía no tiene ninguna factura.',
    latest_only: 'Se muestran las 100 más recientes.',
    companies: 'Empresas',
    email: 'Correo electrónico',
    change_password: 'Cambiar mi contraseña',
    current_password: 'Contraseña actual',
    new_password: 'Nueva contraseña',
    confirm_password: 'Confirmar la nueva contraseña',
    password_rules: 'Al menos 12 caracteres. Una frase de varias palabras sin relación entre sí funciona bien.',
    password_mismatch: 'Las dos contraseñas nuevas no coinciden.',
    password_changed: 'Su contraseña ha sido cambiada.',
    save: 'Guardar',
    download_error: 'No se ha podido descargar el documento.',
    pdf_no_pdf: 'Este documento aún no está disponible para descargar. Por favor, contáctenos.',
    pdf_outdated: 'Esta factura se está actualizando. Contáctenos para recibirla.',
    pdf_not_found: 'Documento no encontrado.',
    nav_quotations: 'Presupuestos',
    quotation: 'Presupuesto',
    status: 'Estado',
    status_pending: 'Pendiente',
    status_in_progress: 'En curso',
    status_invoiced: 'Facturado',
    transport: 'Transporte',
    transport_no: 'N.º de transporte',
    loading_date: 'Fecha de carga',
    estimated_delivery: 'Entrega estimada',
    truck_plate: 'Matrícula del camión',
    trailer_plate: 'Matrícula del remolque',
    aviz: 'Albarán (aviz)',
    not_planned: 'Aún no planificado',
    leaving_teiu: 'Salida de Teiu: {date}',
    leaving_teiu_today: 'Sale de Teiu hoy',
    today: 'Hoy',
    legend_production: 'Producción en curso',
    legend_stock_ready: 'Stock listo',
    legend_transport_searching: 'Buscando transportista',
    legend_transport_confirmed: 'Transportista confirmado',
    incoterms: 'Incoterms',
    view_pdf: 'Ver PDF',
    back: 'Volver',
    trucks_planned: 'Camiones previstos',
    no_quotations: 'No tiene ningún presupuesto pendiente.',
    company: 'Empresa',
    vat_pct: 'IVA %',
    products: 'Productos',
    security: 'Seguridad',
    twofa_title: 'Autenticación en dos pasos',
    twofa_on: 'Activada',
    twofa_off: 'No activada',
    twofa_optional: 'Opcional: al iniciar sesión se le pide un código además de la contraseña.',
    twofa_enable: 'Activar',
    twofa_disable: 'Desactivar',
    twofa_method_totp: 'Aplicación de autenticación',
    twofa_method_email: 'Código por correo electrónico',
    twofa_code: 'Código',
    twofa_send_code: 'Enviarme un código',
    twofa_code_sent: 'Se ha enviado un código a su correo electrónico.',
    twofa_enabled_ok: 'La autenticación en dos pasos está activada.',
    twofa_disabled_ok: 'La autenticación en dos pasos está desactivada.',
    cancel: 'Cancelar',
    nav_dashboard: 'Panel',
    volume: 'Volumen',
    volume_m3: 'Volumen (m³)',
    total_volume: 'Volumen total',
    ready: 'Lista',
    destination: 'Destino',
    display_map: 'Mostrar el mapa',
    upcoming_departures: 'Próximas salidas',
    latest_invoices: 'Últimas facturas',
    purchases_12m: 'Sus pedidos de los últimos 12 meses',
    ordered_this_year: 'Pedido este año',
    volume_in_progress: 'Volumen en curso',
    ref_xylo: 'Ref. XYLO',
    client: 'Cliente',
    vat_number: 'NIF-IVA',
    phone: 'Teléfono',
    billing_address: 'Dirección de facturación',
    delivery_address: 'Dirección de entrega',
    advance_payment: 'Anticipo',
    fsc: 'Certificado FSC',
    yes: 'Sí',
    no: 'No',
    documents: 'Documentos',
    approval_date: 'Fecha de aceptación',
    no_delivery_address: 'Sin dirección de entrega',
    no_upcoming: 'No hay ningún camión previsto por ahora.',
    welcome: 'Bienvenido',
    orders_count: 'Pedidos',
    amount_excl: 'Importe sin IVA',
    click_display_map: 'Haga clic para mostrar el mapa',
    pending_count: 'Presupuestos pendientes: {n}',
    invoices_count: 'Facturas: {n}',
    previous_count: 'Pedidos anteriores: {n}',
    ordered: 'pedidos',
    details: 'Detalles',
    on_the_way: 'En camino',
    all_statuses: 'Todos',
    on_the_road: 'En carretera',
    no_on_the_road: 'Ningún camión en carretera en este momento.'
  },
  nl: {
    nav_orders: 'Lopende bestellingen',
    nav_history: 'Eerdere bestellingen',
    nav_invoices: 'Facturen',
    nav_account: 'Mijn account',
    sign_out: 'Afmelden',
    loading: 'Laden…',
    load_error: 'De gegevens konden niet worden geladen. Probeer het opnieuw.',
    retry: 'Opnieuw proberen',
    order: 'Bestelling',
    your_ref: 'Uw referentie',
    order_date: 'Besteldatum',
    requested_delivery: 'Gewenste levering',
    confirmed_delivery: 'Bevestigde levering',
    awaiting_confirmation: 'Wordt bevestigd',
    truck_planned: 'Vrachtwagen gepland',
    truck_loading: 'laden op {date}',
    truck_delivery: 'verwachte levering op {date}',
    truck_not_planned: 'Vrachtwagen nog niet gepland',
    product: 'Product',
    quantity: 'Aantal',
    unit_price: 'Eenheidsprijs excl. btw',
    line_total: 'Totaal excl. btw',
    vat: 'Btw',
    total_excl: 'Totaal excl. btw',
    total_incl: 'Totaal incl. btw',
    availability: 'Beschikbaarheid',
    in_stock: 'Op voorraad',
    to_prepare: 'In voorbereiding',
    stock_hint: 'Op voorraad: de goederen staan klaar. In voorbereiding: de goederen worden voor uw bestelling geproduceerd of klaargemaakt.',
    download_pdf: 'PDF',
    pdf_unavailable: 'PDF nog niet beschikbaar',
    no_current_orders: 'U hebt geen lopende bestelling.',
    no_previous_orders: 'U hebt geen eerdere bestelling.',
    invoice: 'Factuur',
    invoices_of_order: 'Factuur/facturen',
    invoice_no: 'Nummer',
    date: 'Datum',
    type: 'Soort',
    kind_invoice: 'Factuur',
    kind_credit_note: 'Creditnota',
    kind_advance: 'Voorschotfactuur',
    amount_incl: 'Bedrag incl. btw',
    no_invoices: 'U hebt nog geen factuur.',
    latest_only: 'De 100 meest recente worden getoond.',
    companies: 'Bedrijven',
    email: 'E-mail',
    change_password: 'Mijn wachtwoord wijzigen',
    current_password: 'Huidig wachtwoord',
    new_password: 'Nieuw wachtwoord',
    confirm_password: 'Bevestig het nieuwe wachtwoord',
    password_rules: 'Minstens 12 tekens. Een zin van meerdere losse woorden werkt goed.',
    password_mismatch: 'De twee nieuwe wachtwoorden komen niet overeen.',
    password_changed: 'Uw wachtwoord is gewijzigd.',
    save: 'Opslaan',
    download_error: 'Het document kon niet worden gedownload.',
    pdf_no_pdf: 'Dit document is nog niet beschikbaar om te downloaden. Neem contact met ons op.',
    pdf_outdated: 'Deze factuur wordt bijgewerkt. Neem contact met ons op om ze te ontvangen.',
    pdf_not_found: 'Document niet gevonden.',
    nav_quotations: 'Offertes',
    quotation: 'Offerte',
    status: 'Status',
    status_pending: 'In afwachting',
    status_in_progress: 'Lopend',
    status_invoiced: 'Gefactureerd',
    transport: 'Transport',
    transport_no: 'Transportnr.',
    loading_date: 'Laaddatum',
    estimated_delivery: 'Verwachte levering',
    truck_plate: 'Kenteken vrachtwagen',
    trailer_plate: 'Kenteken oplegger',
    aviz: 'Begeleidingsbon (aviz)',
    not_planned: 'Nog niet gepland',
    leaving_teiu: 'Vertrek uit Teiu: {date}',
    leaving_teiu_today: 'Vertrekt vandaag uit Teiu',
    today: 'Vandaag',
    legend_production: 'Productie loopt',
    legend_stock_ready: 'Voorraad klaar',
    legend_transport_searching: 'Vervoerder wordt gezocht',
    legend_transport_confirmed: 'Vervoerder bevestigd',
    incoterms: 'Incoterms',
    view_pdf: 'PDF bekijken',
    back: 'Terug',
    trucks_planned: 'Geplande vrachtwagens',
    no_quotations: 'U hebt geen openstaande offerte.',
    company: 'Bedrijf',
    vat_pct: 'Btw %',
    products: 'Producten',
    security: 'Beveiliging',
    twofa_title: 'Tweestapsverificatie',
    twofa_on: 'Ingeschakeld',
    twofa_off: 'Niet ingeschakeld',
    twofa_optional: 'Optioneel: bij het aanmelden wordt naast uw wachtwoord een code gevraagd.',
    twofa_enable: 'Inschakelen',
    twofa_disable: 'Uitschakelen',
    twofa_method_totp: 'Authenticator-app',
    twofa_method_email: 'Code per e-mail',
    twofa_code: 'Code',
    twofa_send_code: 'Stuur mij een code',
    twofa_code_sent: 'Er is een code naar uw e-mailadres gestuurd.',
    twofa_enabled_ok: 'Tweestapsverificatie is ingeschakeld.',
    twofa_disabled_ok: 'Tweestapsverificatie is uitgeschakeld.',
    cancel: 'Annuleren',
    nav_dashboard: 'Dashboard',
    volume: 'Volume',
    volume_m3: 'Volume (m³)',
    total_volume: 'Totaal volume',
    ready: 'Klaar',
    destination: 'Bestemming',
    display_map: 'Kaart tonen',
    upcoming_departures: 'Komende vertrekken',
    latest_invoices: 'Laatste facturen',
    purchases_12m: 'Uw bestellingen van de laatste 12 maanden',
    ordered_this_year: 'Dit jaar besteld',
    volume_in_progress: 'Volume lopend',
    ref_xylo: 'XYLO-ref.',
    client: 'Klant',
    vat_number: 'Btw-nummer',
    phone: 'Telefoon',
    billing_address: 'Factuuradres',
    delivery_address: 'Afleveradres',
    advance_payment: 'Voorschot',
    fsc: 'FSC-gecertificeerd',
    yes: 'Ja',
    no: 'Nee',
    documents: 'Documenten',
    approval_date: 'Datum van aanvaarding',
    no_delivery_address: 'Geen afleveradres',
    no_upcoming: 'Er is momenteel geen vrachtwagen gepland.',
    welcome: 'Welkom',
    orders_count: 'Bestellingen',
    amount_excl: 'Bedrag excl. btw',
    click_display_map: 'Klik om de kaart te tonen',
    pending_count: 'Openstaande offertes: {n}',
    invoices_count: 'Facturen: {n}',
    previous_count: 'Eerdere bestellingen: {n}',
    ordered: 'besteld',
    details: 'Details',
    on_the_way: 'Onderweg',
    all_statuses: 'Alle',
    on_the_road: 'Onderweg',
    no_on_the_road: 'Er is momenteel geen vrachtwagen onderweg.'
  }
}

export const LANGS = Object.keys(T)

export function portalLang (lang) {
  return LANGS.includes(lang) ? lang : 'en'
}

/** t(lang, 'truck_loading', { date: '12/11/2026' }) */
export function translate (lang, key, vars) {
  const dict = T[portalLang(lang)]
  let s = dict[key] !== undefined ? dict[key] : (T.en[key] !== undefined ? T.en[key] : key)
  if (vars) Object.keys(vars).forEach(k => { s = s.replace(`{${k}}`, vars[k]) })
  return s
}

const DATE_SEP = { de: '.', nl: '-' }

export const LOCALES = { en: 'en-GB', fr: 'fr-FR', ro: 'ro-RO', de: 'de-DE', es: 'es-ES', nl: 'nl-NL' }

/** 'YYYY-MM-DD' → JJ/MM/AAAA (JJ.MM.AAAA en DE, JJ-MM-AAAA en NL). */
export function formatDate (lang, ymd) {
  if (!ymd) return ''
  const m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!m) return String(ymd)
  const sep = DATE_SEP[portalLang(lang)] || '/'
  return [m[3], m[2], m[1]].join(sep)
}

/** Même rendu que les PDF (formatMillier côté API) : « 1 234.56 ». */
export function formatAmount (value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  const [int, dec] = Math.abs(n).toFixed(2).split('.')
  return `${n < 0 ? '-' : ''}${int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}.${dec}`
}
